import selectFolderWithFallback from './selectFolderWithFallback';
import { singleSelectRow } from 'owa-mail-actions';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
export default function selectFolderAndRow(folderId, rowId) {
    selectFolderWithFallback(folderId);
    var tableView = getSelectedTableView();
    var rowKey = getRowKeysFromRowIds([rowId], tableView)[0];
    if (tableView.rowKeys.includes(rowKey)) {
        singleSelectRow(tableView, rowKey, true /* isUserNavigation */, MailListItemSelectionSource.RouteHandler);
    }
    // 2017: Reading Pane: Conversation route handler for conversations moved\deleted or hasn't been loaded by listview
}
//# sourceMappingURL=selectFolderAndRow.js.map